import {HIDE_CREATE_DEBATE_SUCCESS} from "./types";

export const hideSuccess = () => dispatch => {
    dispatch({
        type: HIDE_CREATE_DEBATE_SUCCESS
    })
}